import { jsx as _jsx } from "react/jsx-runtime";
export const SvgLayers = (props) => (_jsx("svg", { xmlns: 'http://www.w3.org/2000/svg', xmlSpace: 'preserve', viewBox: '0 0 24 24', ...props, children: _jsx("path", { d: 'm20 16.3-8 3.9-8-4m16-3.9-8 3.9-8-4M12 4l8 4-8 4-8-4z' }) }));
//# sourceMappingURL=layers.js.map